import { CheckCircleOutlined } from "@mui/icons-material";
import { Button, Skeleton, Stack } from "@mui/material";
import { useState } from "react";
import { CreateTaskItemModal, TaskItemLabel } from "src/components";
import { ItemProperty } from "..";
import { SupportingItemType } from "../../constants";
import { SupportingTaskItemDto } from "../../http";

interface IProps {
  items: SupportingTaskItemDto[];
  context?: {
    teamName: string;
    teamSlug: string;
    actionItemGuid: string;
    actionItemDescription: string;
  };
  parentTask?: {
    taskItemGuid: string;
    description: string;
  };
  isLoading?: boolean;
  onClick?: (type: SupportingItemType, taskItemGuid: string) => void;
}

const SupportingTaskItemsProperty = (props: IProps) => {
  const [isTaskItemModalVisible, setIsTaskItemModalVisible] = useState(false);

  function handleClicked(event: React.MouseEvent, taskItemGuid: string) {
    if (props.onClick) {
      event.preventDefault();
      props.onClick(SupportingItemType.TaskItem, taskItemGuid);
    }
  }

  return (
    <ItemProperty labelIcon={<CheckCircleOutlined />} label="Tasks">
      <Stack spacing={0.5}>
        {props.isLoading ? (
          <Stack spacing={0.5}>
            {[95, 150, 120].map((width, i) => (
              <Skeleton key={i} variant="rectangular" height={24} width={width} />
            ))}
          </Stack>
        ) : (
          props.items.map((taskItem) => (
            <TaskItemLabel
              taskItemGuid={taskItem.taskItemGuid}
              taskItemDescription={taskItem.description}
              taskItemStatus={taskItem.currentStatus}
              taskItemTeam={taskItem.team}
              onClick={(e) => handleClicked(e, taskItem.taskItemGuid)}
            />
          ))
        )}

        <Button
          variant="tertiary"
          startIcon={<CheckCircleOutlined />}
          sx={{ alignSelf: "start" }}
          onClick={() => setIsTaskItemModalVisible(true)}
        >
          Add
        </Button>
      </Stack>

      <CreateTaskItemModal
        visible={isTaskItemModalVisible}
        context={props.context}
        parentTask={props.parentTask}
        onCreated={() => setIsTaskItemModalVisible(false)}
        onCancelled={() => setIsTaskItemModalVisible(false)}
      />
    </ItemProperty>
  );
};

export { SupportingTaskItemsProperty };
